import { combineReducers } from 'redux';

import * as types from 'modules/cameras/actionTypes';
import { DETAILS_SOURCE } from 'modules/cameras/constants';
import type { Action } from 'modules/global/generic.types';
import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import isPairingModalOpen from './isPairingModalOpen';

const detailPageActionMatcher = ({ meta }: Action) => meta?.source === DETAILS_SOURCE;

export default combineReducers({
  loading: combineReducers({
    update: loading(types.PUT_CAMERA, { global: { matcher: detailPageActionMatcher } }),
    create: loading(types.POST_CAMERA, { global: { matcher: detailPageActionMatcher } }),
    fetch: loading(types.FETCH_CAMERA, { global: { matcher: detailPageActionMatcher } }),
    scans: loading(types.FETCH_CAMERA_SCANS),
    pairing: loading(types.POST_CAMERA_TV_PAIRING),
  }),
  ready: createReducer(false, {
    [types.SET_IS_READY]: () => true,
    [LOCATION_CHANGE]: () => false,
  }),
  isPairingModalOpen,
});
